import React, { Fragment } from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { BUSINESS_FIELDS, fullName } from '@modules/form-wizard/utils'
import moment from 'moment'
import toastr from '@modules/toastr'
import Swal from 'sweetalert2'
import { ValidatorForm } from 'react-form-validator-core'
import Modal from 'react-responsive-modal'
import Loader from '@shared/loader'
import DateTimeField from '@shared/form-fields/date'

export default class SpecialVehicleLicense extends React.Component {
  resource = '/special_vehicle_licenses'
  form_key = 'special_vehicle_license'
  defaults = {}
  state = { record: null, loading: false, date: new Date(), clinic: {} }

  // Delete lines as needed
  fee           = 99
  free          = true
  postpaid      = false
  skip_location = true
  hide_buttons  = {
    status: true,
    deny: false,
    approve: true,
  }
  custom_actions = [
    {
      text: 'Confirm Appointment Date',
      icon: 'chevron-right',
      roles: [['officer', 'senior_officer']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => this.setState({ record })
    },

    {
      text: 'Approve',
      icon: 'chevron-right',
      roles: [['officer', 'senior_officer']],
      test: r => ['awaiting inspection'].includes(r.application_decision),
      fn: async record => this.approve(record)
    },
  ]
  business_only = true

  validate = null

  foremost = null

  /*
  
  t.string :form_num
t.string :payment_amount
t.string :payment_invoice
t.string :payment_status
t.string :application_status
t.string :application_decision, default: 'pending'
t.boolean :acceptance, default: false
t.boolean :declare, default: false
t.string :pickup_location
t.string :pickup_sub_location
t.belongs_to :user, foreign_key: true
t.belongs_to :delivery, foreign_key: true, null: true
t.belongs_to :officer, foreign_key: { to_table: :users }, null: true
t.belongs_to :proxy, foreign_key: { to_table: :users }, null: true
t.string :delivery_status
t.date :app_status_change_date
t.string :ip_address
t.boolean :requested_proxy, default: false

t.string :registration_numb
t.string :chassis_numb
t.string :vehicle_make
t.string :vehicle_type
t.string :gross_weight
t.string :number_of_axles
t.string :axle_load1
t.string :axle_load2
t.string :axle_load3
t.string :axle_load4
t.string :axle_dist_1_2
t.string :axle_dist_2_3
t.string :axle_dist_3_4
t.string :axle_1_wheel_numb
t.string :axle_2_wheels_numb
t.string :axle_3_wheels_numb
t.string :axle_4_wheels_numb
t.string :track_inside_wheels
t.string :dist_inside_wheels
t.string :overall_length_vehicle
t.string :overall_length_trailer
t.string :overall_length_both
  
  */

  fields = form => [
    ...BUSINESS_FIELDS(form),
    {
      name: 'confirmed_appointment_date',
      label: 'Confirmed Appointment Date',
      type: 'date',
      hide: true,
      view: {
        element: (value, form) => form.confirmed_appointment_date ? (
            <Fragment>
              <h5 className='sub'>Confirmed Appointment Date</h5>
              <p>{moment(value).format('MMMM DD, YYYY hh:mm A')}</p>
            </Fragment>
          ) : (
            <Fragment>
              <h5 className='sub'>Confirmed Appointment Date</h5>
              <p>N/A</p>
            </Fragment>
          )
      }
    },
 
    {
      name: 'registration_numb',
      label: 'Registration number (Licence Plate Number)',
    },
    {
      name: 'trailer_serial_numb',
      label: 'Trailer Serial #',
    },
    {
      name: 'year_built',
      label: 'Year Built',
      type: 'date',
      showYearDropdown: true,
    },
    // {
    //   name: 'company_name',
    //   label: 'Company Name',
    //   options: [
    //     'Rubis',
    //     'Esso',
    //     'Shell'
    //   ]
    // },
    {
      name: 'chassis_numb',
      label: 'Chassis number',
    },
     {
        name: 'vehicle_make',
        label: 'Make of vehicle(s)',
    },
    {
        name:'vehicle_type',
        label: 'Type of vehicle/Trailer',
    },
     {
        name: 'gross_weight',
        label: 'Total Gross Weight',
    },
     {
        name: 'number_of_axles',
        label: 'Number of Axles',
        is:'integer',
    },
     {
        name: 'axle_load1',
        label: 'Load on Axle 1',
        is:'integer',
    },
     {
        name: 'axle_2_wheels_numb',
        label: 'Load on Axle 2',
        is:'integer',
    },
     {
        name: 'axle_load3',
        label: 'Load on Axle 3',
        is:'integer',
    },
     {
        name: 'axle_load4',
        label: 'Load on Axle 4',
        is:'integer',
    },
     {
        name: 'axle_dist_1_2',
        label: 'Distance Axle 1 to Axle 2',
    },
     {
        name: 'axle_dist_2_3',
        label: 'Distance Axle 2 to Axle 3',
    },
     {
        name: 'axle_dist_3_4',
        label: 'Distance Axle 3 to Axle 4',
    },
     {
        name: 'axle_1_wheel_numb',
        label: 'Number of wheels per Axle 1',
        is:'integer',
    },
     {
        name: 'axle_2_wheel_numb',
        label: 'Number of wheels per Axle 2',
        is:'integer',
    },
     {
        name: 'axle_3_wheel_numb',
        label: 'Number of wheels per Axle 3',
        is:'integer',
    },
     {
        name: 'axle_4_wheel_numb',
        label: 'Number of wheels per Axle 4',
        is:'integer',
    },
     {
        name: 'track_inside_wheels',
    },
     {
        name: 'dist_inside_wheels',
        label: 'Distance inside wheels',
    },
     {
        name: 'overall_length_vehicle',
        label: 'Overall length of vehicle',
    },
     {
        name: 'overall_length_trailer',
        label: 'Overall length of trailer',
    },
     {
        name: 'overall_length_both',
        label: 'Overall length of both',
    },
  ]


  // Custom Action Functions
    setAppt = async () => {
      const { props, state, resource, form_key } = this
      const { history, location } = props
      const { date, record } = state
  
      this.setState({ loading: true })
  
      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: 'approved',
            confirmed_appointment_date: new Date(date),
          },
        })
  
        if (location?.state?.view) {
          const view = { ...location.state.view }
          view.application_decision = 'approved'
  
          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }
  
        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      } finally {
        this.setState({ record: null, loading: false })
      }
    }
  
    async approve(record) {
      let inputOpts = {
        'approve': "Approve Application",
      }
  
      let value = null

      const firstStep = await Swal.fire({
        icon: 'question',
        title: 'Approve Application',
        html: `
          Approve application after thorough inspection, 
          <strong>${fullName(record.user, 'initial')}</strong>, for
          <br/>${moment(this.state.record?.appointment_date).format('MMMM DD, YYYY hh:mm A')}?
        `,
        input: 'select',
        inputOptions: inputOpts,
        showCancelButton: true,
        confirmButtonText: 'Approve',
      })

      if (firstStep.isDismissed) return
      value = firstStep.value
    
      this.setState({ loading: true })
    
      const { props, resource, form_key } = this
      const { history, location } = props
      const { axios } = $app
    
      try {
        await axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })
    
        if (location.state?.view) {
          const view = { ...location.state.view }
          view.application_decision = 'approved'
    
          history.replace(location.pathname, { ...location.state, view })
        }
    
        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        toastr.error('Error', 'Unable to update application')
        return
      }
    
      this.setState({ loading: false })
    }

  closeModal = () => this.setState({ record: null })
  onChange = date => this.setState({ date })

  render = () => (
    <Fragment>
      <Loader loading={this.state.loading} />
      <Wizard {...SERVICE_PROPS(this)} />
      <Modal
        open={!!this.state.record && !this.state.loading}
        onClose={this.closeModal}
        classNames={{ modal: 'w-full sm:w-128' }}
        center
      >
        <header className='modal-header'>
          <h4 className='mb-0'>Confirm Appointment Date</h4>
        </header>
        <ValidatorForm onSubmit={this.setAppt}>
          <article className='modal-body'>
            <label htmlFor='selected_date' className='form-label'>
              Current selected date
            </label>
            <div name='selected_date' className='font-bold'>{moment(this.state.record?.confirmed_appointment_date).format('MMMM DD, YYYY hh:mm A')}</div>
          </article>
          <article className='modal-body'>
            <label htmlFor='date' className='form-label'>
              Please set the applicant's appointment date
            </label>
            <DateTimeField
              name='date'
              dateFormat="MMMM d, yyyy h:mm aa"
              timeInputLabel="Time:"
              showTimeInput
              icon={null}
              minDate={new Date()}
              selected={this.state.date}
              value={new Date(this.state.record?.confirmed_appointment_date)}
              onChange={this.onChange}
              validators={['required']}
              errorMessages={['Please enter a valid date']}
              className='form-control'
              required
            />
          </article>
          <footer className='modal-footer'>
            <button type='button' className='btn' onClick={this.closeModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-primary'>
              Submit
            </button>
          </footer>
        </ValidatorForm>
      </Modal>
    </Fragment>
  )
}
